import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { ConsumptionCard, DashboardContext, Icon, OrdersTable, Skeleton } from 'components';
import { useUser } from 'hooks';
import { appService } from 'services';

const DashboardAccount = () => {
  const { tabs, navigateTo, consumptionsData, consumptionsLoading, getConsumption } = useContext(DashboardContext);
  const { currentUser } = useUser();
  const { t } = useTranslation();

  useEffect(() => {
    if (currentUser?.serialNumber) {
      getConsumption();
    }
  }, [currentUser]);

  return (
    <>
      <div className="lg:hidden">
        <h1 className="h1 underlined-yellow mb-16">{t('dashboard:titles.account')}</h1>
        {tabs.map((tab, i) => (
          <button key={`user-menu-${i}`} type="button" className="tab-trigger" onClick={() => navigateTo(tab, i)}>
            <Icon
              name={tab.icon.name}
              iconStyle={tab.icon.style}
              classes="h-6 w-6 text-white bg-primary-500 p-3 rounded-xl"
            />
            <div className="grow flex flex-col items-start">
              <p className="text-sm font-bold uppercase tab-label">{tab.label}</p>
              <p className="text-gray-500 text-sm text-left">{tab.caption}</p>
            </div>
            <Icon name="chevron-right" />
          </button>
        ))}
      </div>

      <div className="hidden gap-10 lg:grid lg:grid-cols-12">
        {consumptionsLoading && (
          <>
            {[...Array(3)].map((_, index) => (
              <div
                className="rounded-xl h-44 overflow-hidden mb-4 lg:mb-0 lg:col-span-4"
                key={`consumption-skeleton-${index}`}
              >
                <Skeleton type="text" classNames="h-full w-full" />
              </div>
            ))}
          </>
        )}

        {!consumptionsLoading && consumptionsData && (
          <>
            {consumptionsData.map((consumption, index) => (
              <div className="mb-4 lg:mb-0 lg:col-span-4" key={`consumption-${index}`}>
                <ConsumptionCard consumption={consumption} index={index} />
              </div>
            ))}
          </>
        )}

        <div className="mt-12 lg:mt-0 lg:col-span-12">
          <OrdersTable limit={appService.isArrivaj()} />
        </div>
      </div>
    </>
  );
};

export default DashboardAccount;
